export const sections = [
    {
        title: "Home",
        url: "/#",
    },
    {
        title: "Jennifer Mnookin",
        url: "/#jennifer-mnookin",
    },
    {
        title: "Leadership Turnover",
        url: "/#leadership-turnover",
    },
    {
        title: "Credits",
        url: "/#credits",
    }
];